import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateId(): string {
  return crypto.randomUUID();
}

// "N of M respondents" frequency for a synthesised node, or null when there's
// nothing to show (count not positive). M (total) is optional — nodes promoted
// before it was captured don't carry it, in which case it's just "N
// respondents". Pluralises on the trailing number (M when present, else N).
export function formatRespondentFrequency(count?: number, total?: number): string | null {
  if (typeof count !== 'number' || count <= 0) return null;
  if (typeof total === 'number' && total > 0) {
    return `${count} of ${total} respondent${total === 1 ? '' : 's'}`;
  }
  return `${count} respondent${count === 1 ? '' : 's'}`;
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(typeof date === 'string' ? new Date(date) : date);
}

export function formatRelativeTime(date: string | Date): string {
  const now = new Date();
  const then = typeof date === 'string' ? new Date(date) : date;
  const diffMs = now.getTime() - then.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(date);
}
